import { Helmet } from 'react-helmet-async';

const SITE = {
  url: 'https://geniusacademyklbg.com',
  name: 'Genius Academy',
  tagline: 'Technical and Computer Training Institute',
  city: 'Kalaburagi',
  region: 'Karnataka',
  country: 'India',
  logo: 'https://customer-assets.emergentagent.com/job_33cef519-6a19-4ccb-ace7-ff1a08bb6e04/artifacts/209s83l6_11%20%285%29.png',
  ogImage: 'https://customer-assets.emergentagent.com/job_33cef519-6a19-4ccb-ace7-ff1a08bb6e04/artifacts/209s83l6_11%20%285%29.png',
  twitter: '@geniusacademy',
};

/**
 * SEO component - injects title, meta, canonical, Open Graph, Twitter, and JSON-LD.
 * Does not affect layout or design.
 */
const SEO = ({
  title,
  description,
  path = '/',
  image = SITE.ogImage,
  keywords = '',
  jsonLd = null,
  breadcrumbs = null,
  noindex = false,
}) => {
  const canonical = `${SITE.url}${path}`;
  const fullTitle = title ? `${title} | ${SITE.name}` : `${SITE.name} — ${SITE.tagline}`;

  const breadcrumbJsonLd = breadcrumbs
    ? {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbs.map((b, i) => ({
          '@type': 'ListItem',
          position: i + 1,
          name: b.name,
          item: `${SITE.url}${b.path}`,
        })),
      }
    : null;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <link rel="canonical" href={canonical} />
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : <meta name="robots" content="index, follow, max-image-preview:large" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={SITE.twitter} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd ? <script type="application/ld+json">{JSON.stringify(jsonLd)}</script> : null}
      {breadcrumbJsonLd ? <script type="application/ld+json">{JSON.stringify(breadcrumbJsonLd)}</script> : null}
    </Helmet>
  );
};

export { SITE };
export default SEO;
